import { Box, styled, Tooltip } from '@mui/material';

import React, { useEffect } from 'react';
import Image from '~/components/Image';
import { Link } from '~/components/Link';
import { useExtensionDetails } from '~/scripts/extension';
export const ChromeWebstoreTeaser = () => {
  const [hovering, setHovering] = React.useState(false);
  const [shaking, setShaking] = React.useState(false);
  const extension = useExtensionDetails();

  useEffect(() => {
    const timeouts: ReturnType<typeof setTimeout>[] = [];
    timeouts.push(
      setTimeout(() => {
        setShaking(true);
      }, 5e3)
    );
    timeouts.push(
      setTimeout(() => {
        setShaking(false);
      }, 8e3)
    );
    timeouts.push(
      setTimeout(() => {
        setShaking(true);
      }, 30e3)
    );
    timeouts.push(
      setTimeout(() => {
        setShaking(false);
      }, 35e3)
    );

    return () =>
      timeouts.forEach((timeout) => {
        clearTimeout(timeout);
      });
  }, []);

  return (
    <Tooltip
      open={shaking || hovering}
      title={`Try our free ${extension.browser} Extension`}>
      <Webstore
        className={`webstore ${shaking || hovering ? 'open' : ''} ${
          shaking ? 'shaking' : ''
        }`}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        sx={{
          display: {
            xs: 'none',
            sm: 'none',
            md: 'none',
            lg: 'block',
          },
        }}>
        <WebstoreLink href="/extension?utm_source=nerdydata-teaser">
          <Image src={extension.logo} alt="Extension Logo" />
        </WebstoreLink>
      </Webstore>
    </Tooltip>
  );
};

const WebstoreLink = styled(Link)`
  :before {
    content: '';
    position: absolute;
    background: #e4e4e4;
    width: 100%;
    left: 0;
    height: 50px;
    top: 0px;
    z-index: -2;
  }
  :after {
    content: '';
    position: absolute;
    top: 10px;
    width: 30px;
    height: 10px;
    background: #fafefb;
    border-radius: 12px;
    left: calc(50% - 15px);
    z-index: -1;
  }
  img {
    z-index: 3;
    position: relative;
    height: 90px;
    bottom: -20px;
  }
`;

const Webstore = styled(Box)`
  position: fixed;
  bottom: -50px;
  right: 160px;
  transition: all 0.2s ease-in;
  padding: 5px 15px 0;
  background: #f3f3f3;
  border-radius: 0 0 17px 17px;
  z-index: 9;

  &.open {
    bottom: 0;
  }

  &.shaking {
    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both infinite;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }
    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }
    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }
    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;
